import React  from 'react';
import {Alert , Form  , Card , Row , Col , Button} from 'react-bootstrap'
import ReactDOM from "react-dom";
import Checkbox from '../../checkbox.js';

class SelectFields extends React.Component {


    constructor(props) {
        super();
        this.props = props;

        var csv = this.props.data.csv || [[] , []];
        this.props.data.fields = {

        };

        this.props.data.headerRow = true;

        this.state = {
            csv: csv.slice(0, 2),
            cols: csv[1],
            headerRow:true,
            fields: [
                {name: "---- Don't map this field ----", id: ""},
                {name: "Full Name",  id: "fullname"},
                {name: "First Name", id: "first_name"},
                {name: "Last Name",  id: "last_name"},
                {name: "Class Name*", id: "class_name"},
            ]
        };
    }

    handleChange(index , event) {

        this.props.data.fields[index] = event.target.value

        if(this.props.data.fields[index].trim() == "" || this.props.data.fields[index].trim().length == 0)
        {
            delete this.props.data.fields[index];
        }

    }

    renderRows() {
        let rows = [];

        for (var idx = 0; idx < this.state.cols.length; idx++) {

            let fields = [];
            for (var jdx = 0; jdx < this.state.fields.length; jdx++) {
                fields.push(<option value={this.state.fields[jdx].id} >{this.state.fields[jdx].name}</option>)
            }


            rows.push(<Row>
                <Col md={6}>{this.state.cols[idx]}</Col>
                <Col md={6}><Form.Control onChange={this.handleChange.bind(this , idx)} as="select">
                    {fields}
                </Form.Control></Col>

            </Row>);

            rows.push(<br/>)
        }

        return rows;
    }

    render() {

        return  <div style={{padding:"20px"}}>
            <Card.Title>Student Import <small><i class="fas fa-chevron-right"></i></small>   Step 2: Select Field</Card.Title>
            <Row>
                <Col md={12}>
                    <small><p>Match your columns to the relevant fields , If you decided to leave the username , password or nickname blank the importer will generate them for you. Please be aware the Nickname is the displayed name for the application , app store and highscore tables. Additionally if you wish to add students to multiple classes match the class name column to multiple fields (Note blanks are ignored)</p></small>
                </Col>
            </Row>
            <Row>
                <Col md={12}>
                    <Form.Group controlId="header">
                        <Checkbox checked={this.state.headerRow} onChange={(event)=>{ console.log(event.target.checked); this.setState({
                                headerRow:event.target.checked,
                                cols:event.target.checked ? this.state.csv[1] : this.state.csv[0]
                        })

                        this.props.data.headerRow = event.target.checked

                        }} type="checkbox" label="Has a header row" />
                    </Form.Group>
                </Col>
            </Row>
            {this.renderRows.bind(this)()}
            <Button>Add Field</Button>
            <br/>
        </div>;

    }
}

export default {
    name: "Select",
    icon:<i class="fa-2x  fas fa-clipboard-check"></i>,
    title:null,
    onSubmit: function (done){

        var hasInternalID = false;
        var hasClassName = false;
        var hasName = false;

        for(var key in this.props.data.fields)
        {
            if(!this.props.data.fields.hasOwnProperty(key)) continue;

            if(this.props.data.fields[key] == "internal_uid")
            {
                hasInternalID = true;
            }

            if(this.props.data.fields[key] == "fullname" || this.props.data.fields[key] == "first_name" ||  this.props.data.fields[key] == "last_name")
            {
                hasName = true;
            }
        }

        //if(!hasInternalID) return done({message:"You need to specify a identification number this is needed for when updating students on mass this value is found on your school information management system"});
        if(!hasName) return done({message:"You need to specify a name field for your students you can use fullname , first name or lastname "});

        done();
    },
    onBack:function(done){
        done();
    },
    component: SelectFields
}